<template>
     <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card v-if="language">
            <v-toolbar flat color="#008dd4" dark>
                <v-btn icon @click="$parent.show_dialog = false">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title>Examen : {{language.language}}</v-toolbar-title>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-container fluid class="pt-0">
                <v-row justify="center" align="center" class="my-0 px-0">
                    <v-col cols="12" class="pa-0">
                        <v-sheet class="" color="#008dd4" height="10vh"></v-sheet>
                    </v-col>
                    <v-col cols="12" lg="8" md="8" sm="12" style="position:relative; margin-top: -50px">
                        <v-card outlined class="mb-3">
                            <v-card-title>{{ language.exam.title }}</v-card-title>
                            <v-divider></v-divider>
                            <v-card-text>
                                {{ language.exam.description ? language.exam.description : 'Sin descripción' }}
                            </v-card-text>
                        </v-card>
                        <v-card class="mb-3" v-for="(question, index) in JSON.parse(language.exam.questions)" :key="index" outlined>
                            <v-card-title>Pregunta {{ index+1 }}</v-card-title>
                            <v-divider></v-divider>
                            <v-card-text>
                                <div v-if="question.type === 'question'">
                                    <strong>
                                        {{ question.value }}
                                    </strong>
                                </div>
                                <div v-else>
                                    <v-row justify="center" align="center">
                                        <v-col cols="12" lg="6" md="6" sm="12">
                                            <div class="embed-container" v-html="question.value"></div>
                                        </v-col>
                                    </v-row>
                                </div>
                                <v-list>
                                    <v-subheader>Opciones</v-subheader>
                                    <v-list-item v-for="(option, index) in question.options" :key="index">
                                        <v-list-item-icon>
                                            <v-icon v-if="option.correct" color="success">mdi-check-bold</v-icon>
                                            <v-icon v-else color="error">mdi-close-thick</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-content>
                                            <v-list-item-title>{{ option.value }}</v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
        </v-card>
    </v-dialog>
</template>
<style>
    .embed-container {
        position: relative;
        padding-bottom: 56.25%;
        height: 0;
        overflow: hidden;
    }
    .embed-container iframe {
        position: absolute;
        top:0;
        left: 0;
        width: 100%;
        height: 100%;
    }
</style>
<script>
export default {
    props:['language','dialog']
}
</script>